import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderComponent } from './components/header/header.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ModalComponent } from './components/modal/modal.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { TranslateModule } from '@ngx-translate/core';
import { SelectComponent } from './components/select/select.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { LoaderComponent } from './components/loader/loader.component';
import { SearchSelectComponent } from './components/search-select/search-select.component';
import { ContractService } from '../features/contract/contract.service';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { ChunkPipe } from './pipe/chunk.pipe';
import { ShortNumberPipe } from './pipe/short-number.pipe';
import { OnlyAlphabetDirective } from './directives/only-alphabet.directive';
import { DropdownFlipDirective } from './directives/dropdown-flip.directive';
import { FooterComponent } from './components/footer/footer.component';
import { DashboardModule } from '../features/dashboard/dashboard.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    PaginationComponent,
    ModalComponent,
    BreadcrumbComponent,
    SelectComponent,
    ClickOutsideDirective,
    OnlyNumberDirective,
    TooltipDirective,
    OnlyAlphabetDirective,
    LoaderComponent,
    SearchSelectComponent,
    CustomSelectComponent,
    ChunkPipe,
    ShortNumberPipe,
    DropdownFlipDirective,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    FontAwesomeModule,
    TranslateModule,
  ],
  providers: [
    ContractService
  ],
  exports: [SidebarComponent, SearchSelectComponent, HeaderComponent, PaginationComponent, ModalComponent, BreadcrumbComponent, SelectComponent, FooterComponent, LoaderComponent, OnlyNumberDirective, ClickOutsideDirective, TooltipDirective, CustomSelectComponent, ChunkPipe, ShortNumberPipe, OnlyAlphabetDirective, DropdownFlipDirective, HeaderComponent],
})
export class SharedModule { }
